<template>
    <div class="strategy_main">
        <!--        <img src="@/assets/backgroundPicture.png" style="{display: none}" class="big_cat_blur_backgroud"/>-->
        <div class="common_background"></div>
        <div id="navigation_title" v-if="!isWeixinBrowser()" class="navigation" :style="{height:getNavCount()+'px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><i class="icon-thin_back"/></div>
            <div class="clear"></div>
        </div>

        <div v-if="!isWeixinBrowser()" :style="{'padding-top':getNavCount()+'px'}"></div>


        <div id="print" class="transition" :style="{display:showTransition ? '' : 'none'}">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="@/assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="@/Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>概念词汇</span>
                            <img src="@/assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <audio class="audio" :src="greatAudio" id="great_audio" @ended="playEnded('great_audio')" @error="playEnded('great_audio')"/>

        <div class="main_content" ref="mainContent">
            <div class='video_content'>
                <video-player class="video-player vjs-custom-skin"
                              ref="videoPlayer"
                              :playsinline="true"
                              :options="playerOptions"
                              :events="events"
                              @play="onPlayerPlay($event)"
                              @ended="onPlayerEnded($event)"
                              @fullscreenchange="onPlayerFullScreenchange($event)">
                </video-player>
            </div>
        </div>

    </div>
</template>

<script>
    import { videoPlayer } from 'vue-video-player'
    import 'vue-video-player/src/custom-theme.css'
    import 'video.js/dist/video-js.css'
    import Utils from "@/pages/Program/util2";
    import $ from "jquery";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        components: {
            videoPlayer
        },
        data() {
            return {
                lessonId: 0,
                englishProgramVideo: null,
                isFullScreen: false,
                events: ['fullscreenchange'],
                showTransition: false,
                playerOptions: {
                    //播放速度
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: true,
                    // 默认情况下将会消除任何音频。
                    muted: false,
                    // 导致视频一结束就重新开始。
                    loop: false,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: ''
                    }],
                    //你的封面地址
                    poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        //全屏按钮
                        fullscreenToggle: true
                    }
                },
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
            }
        },
        methods: {
            gameQuitClick() {
                this.showTransition = false;
                this.$router.go(-1);
            },
            nextPageClick: function () {
                this.showTransition = false;
                this.$router.replace({name: 'BFFollow', query: {lessonId: this.lessonId}});
            },
            playEnded(idMusicmp3) {
                var musicMp3 = document.getElementById(idMusicmp3);

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            replayClick: function () {
                this.showTransition = false;
                // 重播
                let vVideo = this.$refs.videoPlayer.player;

                if (vVideo != null) {
                    vVideo.play();
                }
            },
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            closeTransition() {
                this.closePage();
            },
            onPlayerPlay: function (e) {
                //此方法不可以在异步方法中执行
                if (e.requestFullscreen) {
                    e.requestFullscreen();
                } else if(e.mozRequestFullScreen) {
                    e.mozRequestFullScreen();
                } else if(e.msRequestFullscreen) {
                    e.msRequestFullscreen();
                } else if(e.oRequestFullscreen) {
                    e.oRequestFullscreen();
                } else if(e.webkitRequestFullscreen) {
                    e.webkitRequestFullScreen();
                }
            },
            onPlayerEnded: function (e) {
                let that = this;
                that.showTransition = true;
                const greatAudio = document.getElementById('great_audio');
                greatAudio.play();

                // 1读前拓展/2概念词汇/3逐页听读/4读后练习
                Utils.$emit('setBigCat5Finished', that.lessonId, 1);

                if (e.exitFullscreen){
                    e.exitFullscreen();
                } else if (e.webkitExitFullscreen) {
                    e.webkitExitFullscreen()
                }
            },
            onPlayerFullScreenchange: function (e) {
                let that = this;

                if (e.isFullscreen() && !that.isFullScreen) {
                    that.isFullScreen = true;
                }

                if (!e.isFullscreen() && that.isFullScreen) {
                    that.isFullScreen = false;
                    // history.go(-1);
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            stopOtherAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:stopOtherAudio";
                }

                if (vPlatform === 4) {
                    window.note.stopOtherAudio();
                }
            },
        },
        created() {
            let that = this;
            let vExplanationVideo = that.$route.query.explanationVideo;
            let vLessonId = parseInt(that.$route.query.lessonId);

            let vedioUrl = that.$qiNiuDomainBase + vExplanationVideo;
            window.console.log(vedioUrl)
            that.playerOptions.poster = vedioUrl + "?vframe/jpg/offset/5";
            that.playerOptions.sources[0].src = vedioUrl;
            that.lessonId = vLessonId;

            setTimeout(function () {
                transformView();
                that.stopOtherAudio();
                $(".vjs-fullscreen-control").click();
            }, 200);
        },
        beforeCreate() {
        },
        activated() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .strategy_main {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
    }

    .main_content {
        position: absolute;
        width: 100%;
        height: calc(100vmax - 100px);
        display: flex;
        align-items: center;
    }

    .video_content {
        display: inline-block;
        width: 100%;
        overflow: hidden;
        background: white;
    }

    .transition {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .transition .content2 {
        text-align: center;
    }

    .transition .content3 {
        text-align: center;
    }
    .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .transition .content .text span {
        display: block;
        text-align: center;
    }
    .transition .content .text .success_tip {
        font-size: 24px;
    }
    .transition .content .star {
        height: 35px;
    }
    .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }
</style>
